"use client";

// screen-edge-flash.tsx
// A brief, full-viewport, pointer-events-none glow around the screen edges —
// a universal (works identically on iOS and Android, unlike vibration)
// attention-getter for incoming push-class notifications while the tab is
// focused. Remounts on every triggerKey change to re-run the CSS animation
// from scratch (key={triggerKey} forces a fresh element instead of relying
// on a class toggle, which wouldn't re-fire if the same key arrives twice in
// a row before the previous animation finishes).

export default function ScreenEdgeFlash({ triggerKey }: { triggerKey: number }) {
  if (triggerKey === 0) return null;
  return (
    <div
      key={triggerKey}
      aria-hidden
      className="fixed inset-0 z-[40] pointer-events-none"
      style={{ animation: "edgeFlash 1.4s ease-out forwards" }}
    />
  );
}
